import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { etapaIsUnlocked } from 'utils/ProjetoUtils';
import SnackbarUtils from 'utils/SnackbarUtils';
import { CustomCard } from '../../../../../components/CustomCard';
import NewAutoCompleteField from '../../../../../components/NewAutoCompleteField/NewAutoCompleteField';
import { loadAssessoresByCoop } from '../../../../../store/modules/AssessoresActions';
import { loadCooperativas } from '../../../../../store/modules/LogradouroActions';
import { loadEducadores } from '../../../../../store/modules/ProfessoresActions';
import { changeProjetoValue } from '../../../../../store/modules/ProjetoActions';
import { Col } from './../../../../../components/Col';
import { GenericProjectCard } from './../../../../../components/GenericProjectCard';
import { Row } from './../../../../../components/Row';
import { loadEscolas } from './../../../../../store/modules/EscolasActions';

const INITIAL_STATE = {
  idEscolaChanged: false,
  cpfsAssessoresChanged: false,
};

class PreEtapa1 extends GenericProjectCard {
  stepIndex = 0;

  validationResults = [false];

  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;

    this.setValue = this.setValue.bind(this);
    this.loadProfessoresByIdEscola = this.loadProfessoresByIdEscola.bind(this);
    this.getAssessores = this.getAssessores.bind(this);
  }

  UNSAFE_componentWillMount() {
    let data = [];
    if (this.props.projeto.idEscola !== -1) {
      data.push(this.props.projeto.idEscola);
    }
    this.props.loadEscolas(
      data,
      () => {
        if (this.props.projeto.idEscola && this.props.projeto.idEscola > -1) {
          this.loadProfessoresByIdEscola(this.props.projeto.idEscola);
        }
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.errorLoadEscolas,
          options: {
            variant: 'error',
          },
        });
      }
    );

    if (this.props.projeto.codigoCooperativa.length > 0) {
      this.loadAssessorByCoop(this.props.projeto.codigoCooperativa);
      this.props.loadCooperativas(false, [
        this.props.projeto.codigoCooperativa,
      ]);
    } else {
      this.props.loadCooperativas();
    }
  }

  getAssessores() {
    if (
      typeof this.props.projeto.codigoCooperativa === 'string' &&
      this.props.projeto.codigoCooperativa.length > 0
    ) {
      if (!this.props.assessores.loadingListByCoop) {
        return this.props.assessores.listByCoop || [];
      }
    }
    return [];
  }

  loadAssessorByCoop(coop) {
    if (coop.length > 0) {
      this.props.loadAssessoresByCoop(
        coop,
        this.props.projeto.cpfsAssessores,
        false,
        null,
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorLoadAssessores,
            options: {
              variant: 'error',
            },
          });
        }
      );
    }
  }

  loadProfessoresByIdEscola(idEscola) {
    this.props.loadEducadores(
      idEscola,
      this.props.projeto.codigoCooperativa,
      this.props.projeto.cpfsProfessores,
      null,
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.errorLoadEducadores,
          options: {
            variant: 'error',
          },
        });
      }
    );
  }

  escolaIsValid() {
    return this.props.projeto.idEscola > 0;
  }

  assessoresIsValid() {
    return this.props.projeto.cpfsAssessores.length > 0;
  }

  setCooperativaByEscolaId(escolaId) {
    const selectedEscola = this.props.escolas.list.filter((escola) => {
      return escola.id === escolaId;
    });
    if (selectedEscola && selectedEscola.length > 0) {
      const coop = selectedEscola[0].coop;
      this.loadAssessorByCoop(coop);
      this.props.changeProjetoValue('codigoCooperativa', coop);
    }
  }

  render() {
    this.validationResults = [this.escolaIsValid(), this.assessoresIsValid()];
    return (
      <CustomCard
        stepIndex={this.stepIndex}
        titleHint={this.props.languageValues.hintPreEtapa}
        CardHeaderPropTypes={{
          title: this.props.languageValues.preCadastro,
        }}
      >
        <form
          className={this.getFormClasses(false)}
          onSubmit={(event) => {
            event.preventDefault();
            if (this.itemsAreValid(this.validationResults)) {
              this.toNext();
            }
          }}
          noValidate
        >
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <NewAutoCompleteField
                label={this.props.languageValues.escola}
                placeholder={
                  this.props.escolas.loadingList
                    ? this.props.languageValues.carregandoEscolas
                    : ''
                }
                options={this.props.escolas.list.map((item) => {
                  return {
                    label: item.nome,
                    value: item.id,
                  };
                })}
                value={this.props.projeto.idEscola}
                onChange={(value) => {
                  const currValue =
                    value && value.value > -1 ? value.value : -1;
                  this.setValue({
                    target: {
                      name: 'codigoCooperativa',
                      value: '',
                    },
                  });
                  this.setValue({
                    target: {
                      name: 'cpfsProfessores',
                      value: [],
                    },
                  });
                  this.setValue({
                    target: {
                      name: 'cpfsAssessores',
                      value: [],
                    },
                  });
                  window.setTimeout(() => {
                    this.setCooperativaByEscolaId(currValue);
                    this.loadProfessoresByIdEscola(currValue);
                    this.setValue({
                      target: {
                        name: 'idEscola',
                        value: currValue,
                      },
                    });
                  }, 10);
                }}
                loading={this.props.escolas.loadingList}
                loadingMessage={this.props.languageValues.carregandoEscolas}
                disabled={
                  this.props.lockedAllFields ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
                error={!this.escolaIsValid()}
                helperText={
                  !this.escolaIsValid()
                    ? this.props.languageValues.validations.escola.required
                    : ''
                }
              />
            </Col>
          </Row>
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <NewAutoCompleteField
                label={this.props.languageValues.cooperativa}
                placeholder={
                  this.props.logradouro.loadingCooperativas
                    ? this.props.languageValues.loadingCooperativas
                    : ''
                }
                options={this.props.logradouro.cooperativas.map((item) => {
                  return {
                    label: item.nome,
                    value: item.codigo,
                  };
                })}
                value={this.props.projeto.codigoCooperativa}
                onChange={(value) => {
                  const currValue =
                    value && value.value.length > 0 ? value.value : '';
                  this.setValue({
                    target: {
                      name: 'codigoCooperativa',
                      value: currValue,
                    },
                  });
                }}
                loading={this.props.logradouro.loadingCooperativas}
                loadingMessage={this.props.languageValues.loadingCooperativas}
                disabled
              />
            </Col>
          </Row>
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <NewAutoCompleteField
                label={this.props.languageValues.assessoresPedagogicos}
                placeholder={
                  this.props.assessores.loadingListByCoop
                    ? this.props.languageValues.carregandoAssessores
                    : ''
                }
                options={this.getAssessores().map((item) => {
                  return {
                    label: item.nome,
                    value: item.cpf,
                  };
                })}
                value={this.props.projeto.cpfsAssessores}
                multiple
                onChange={(value) => {
                  const currValue = value ? value.map((val) => val.value) : [];
                  this.setValue({
                    target: {
                      name: 'cpfsAssessores',
                      value: currValue,
                    },
                  });
                }}
                loading={this.props.assessores.loadingListByCoop}
                loadingMessage={this.props.languageValues.carregandoAssessores}
                disabled={
                  this.props.lockedAllFields ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
                error={!this.assessoresIsValid()}
                helperText={
                  !this.assessoresIsValid()
                    ? this.props.languageValues.validations.assessores.required
                    : ''
                }
              />
            </Col>
          </Row>
          {this.getActionsRow([
            [
              null,
              this.getNextButton(this.itemsAreValid(this.validationResults)),
            ],
          ])}
        </form>
      </CustomCard>
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
  escolas: state.escolas,
  assessores: state.assessores,
  logradouro: state.logradouro,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadEscolas,
      changeProjetoValue,
      loadCooperativas,
      loadAssessoresByCoop,
      loadEducadores,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PreEtapa1);
